import { Teacher } from "./Teacher";

export enum ClassStatus {
  Past = "past",
  Current = "current",
  Future = "future"
}

export interface ScheduleDay {
  start: string;
  end: string;
  halfEnd?: string | null;
  hasSchool: boolean;
  supportsHalf?: boolean;
}

type Month = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

export enum EnrollmentType {
  Full = "full",
  Half = "half"
}

export interface Class {
  id: string;
  created_at: string;
  name: string;
  teacher_id: string;
  start_month: Month;
  start_year: number;
  end_month: Month;
  end_year: number;
  schedule: {
    monday: ScheduleDay;
    tuesday: ScheduleDay;
    wednesday: ScheduleDay;
    thursday: ScheduleDay;
    friday: ScheduleDay;
    saturday: ScheduleDay;
    sunday: ScheduleDay;
  };
  primary_teacher_id?: string;
  primary_teacher?: Teacher;
  secondary_teacher_id?: string;
  secondary_teacher?: Teacher;
  classes_students?: { student_id: string; enrollment_type?: EnrollmentType }[];
  student_count?: { count: number };
}

export const calculateClassStatus = (classItem: Class): ClassStatus => {
  const now = new Date();
  const startDate = new Date(classItem.start_year, classItem.start_month - 1);
  const endDate = new Date(classItem.end_year, classItem.end_month - 1);

  if (now < startDate) {
    return ClassStatus.Future;
  } else if (now > endDate) {
    return ClassStatus.Past;
  } else {
    return ClassStatus.Current;
  }
};
